import { useEffect } from 'react';
import { META } from '../content/site';

const SITE = 'Summerlin';

/**
 * Per-route `<title>` and meta description. A static SPA has one index.html,
 * so each page sets its own on mount and the layout restores nothing — the
 * next page overwrites it.
 */
export function usePageMeta(title: string | null, description: string) {
  useEffect(() => {
    document.title = title ? `${title} — ${SITE}` : `${SITE} — ${META.homeTitle}`;
    const meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (meta) meta.content = description;
  }, [title, description]);
}

export default usePageMeta;
